export const roles = [
{ id: "2", role: "Management" },
{ id: "3", role: "Employee" },
];